// Interface

import util from '@/utils/classToObject'
import { IDataPoolState } from './state';
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem';
import { toStringDictionary } from '@/utils/groupBy';

export class DatapoolGetter {  

  public dataPoolItemsDic(state:IDataPoolState) {
    return toStringDictionary(Object.values(state.dataPoolItemsById),it => it.dtaKey)
  }
  
  public dataPoolItemsValueByKey(state:IDataPoolState,getters:any) {
    return (fullkey:string) => {    
      const item = getters.dataPoolItemsDic[fullkey]
      if(item) {
        const itemNote = (item.dtaNote && item.dtaNote.length > 0)?JSON.parse(item.dtaNote):item.dtaNote
        return itemNote.type == 'json'?
          JSON.parse(item.dtaValue):
          (itemNote.type == 'number'?parseFloat(item.dtaValue):item.dtaValue)
      }
      else return null
    }
  }
}

export default util.classToObject(DatapoolGetter)